import React from "react";

export default function ECLTableCell(props) {
   let flexAlign = "left";
   switch (props.columnInfo?.alignment) {
      case "center":
         flexAlign = "center";
         break;
      case "left":
         flexAlign = "flex-start";
         break;
      case "right":
         flexAlign = "flex-end";
         break;
      default:
         flexAlign = "flex-start";
   }

   let treatedContent = props.content;

   if (
      typeof treatedContent === "number" &&
      !Number.isInteger(props.treatedContent)
   ) {
      treatedContent = treatedContent.toFixed(6);
      treatedContent = treatedContent.toString().replace(/\.?0*$/, "");
   }

   return (
      <div
         role="cell"
         className="ecl-table-cell"
         style={{
            display: props.hide ? "none" : "flex",
            width: props.columnInfo?.width
               ? props.columnInfo.width + "px"
               : Math.floor((1 / props.columnSettings.length) * 100) + "%",
            minWidth: props.columnInfo?.width
               ? props.columnInfo.width + "px"
               : "150px",
            justifyContent: flexAlign,
         }}
      >
         {props.columnInfo?.customFormatting !== undefined ? (
            props.columnInfo.customFormatting(props.tableIndex, props.content)
         ) : (
            <p
               title={
                  props.content !== null && props.content !== undefined
                     ? props.content.toString()
                     : "null"
               }
               style={{
                  textAlign: props.columnInfo?.alignment
                     ? props.columnInfo.alignment
                     : "left",
                  fontWeight: props.columnInfo?.fontWeight
                     ? props.columnInfo.fontWeight
                     : "normal",
               }}
               className={
                  "string-cell " +
                  (props.columnInfo?.textWrap ? "cell-wrapped" : "cell-trunc")
               }
            >
               {props.content !== null && props.content !== undefined
                  ? treatedContent.toString()
                  : ""}
            </p>
         )}
      </div>
   );
}
